import { EffectCallback, useEffect, useRef } from 'react'

/* Use this when you need to know how often dependencies have changed.
 * This is especially useful when a component is mounted before some async data has been loaded.
 */
export function useEffectWithExecutionCount(
  callback: (effectExecutionCount: Number) => ReturnType<EffectCallback>,
  dependencies: unknown[]
) {
  const state = useRef(0)

  useEffect(() => {
    const result = callback(state.current)
    state.current += 1
    return result
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)
}
